import {baseVue as Vue} from 'lvgs-vue-modules';
import errorTrackerPlugin from 'errorTrackerPlugin';
import imageUrlFormatterMixin from 'imageUrlFormatterMixin';

/** Set Plugin */
Vue.use(errorTrackerPlugin);

/** Set Mixin */
Vue.mixin(imageUrlFormatterMixin);

const enabledDebugPerformance = process.env.DEBUG_VUE_PERFORMANCE_ENABLED === 'true';
Vue.config.performance = enabledDebugPerformance;

export default Vue;
